import {useIntl} from 'react-intl'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {MegaMenu} from './MegaMenu'
import {useAuth} from '../../../../../app/modules/auth'
// import { ROLES } from '../../../../../app/routing/PrivateRoutes'
import {useLayout} from '../../../core'
import {getNameByISO3} from '../../../../../app/libs/misc'
import {AbilityContext} from '../../../../../app/modules/auth/core/AbilityContext'
import {useAbility} from '@casl/react'

export function MenuInner() {
  const intl = useIntl()
  const {currentUser} = useAuth()
  const ability = useAbility(AbilityContext)
  // const roleId: number = +currentUser?.role_id!
  const econ: string | null = currentUser?.economy ?? null
  const menuItemList = [
    // {
    //   title: 'Issue Areas',
    //   to: 'issue-areas',
    // },
    // {
    //   title: 'Issue Areas Content Management',
    //   to: 'issue-areas-content-management',
    // },
    // {
    //   title: intl.formatMessage({id: 'MENU.RTA'}),
    //   to: 'agreement',
    // },
    // {
    //   title: intl.formatMessage({id: 'MENU.TRADE_DATA'}),
    //   to: 'trade-data',
    // },
    // {
    //   title: intl.formatMessage({id: 'MENU.TARIFF'}),
    //   to: 'tariff/bound',
    // },
    {
      title: intl.formatMessage({id: 'MENU.HOME'}),
      to: 'home',
      allowedEconomies: ['KHM', 'BGD'],
    },
    {
      title: 'RTA Simulation',
      to: 'third-party-impacts',
      allowedEconomies: ['KHM', 'BGD'],
      submenu: [
        {
          title: `${getNameByISO3(econ)}`,
          to: `third-party-impacts?rep=${econ}`,
        },
        {
          title: 'Other Economies',
          to: 'third-party-impacts',
        },
      ],
    },
    {
      title: 'Trade Prospects',
      to: 'trade-prospect',
      disabled: false,
      allowedEconomies: ['KHM'],
    },
    {
      title: 'Input/Output Analysis',
      to: 'input-output-analysis',
      allowedEconomies: ['KHM', 'BGD'],
    },
    {
      title: 'Preference Loss',
      to: 'preference-loss',
      allowedEconomies: ['KHM', 'BGD'],
    },
    {
      title: intl.formatMessage({id: 'MENU.CGE'}),
      to: 'cge',
      allowedEconomies: ['BGD'],
    },
  ]

  // const canAccess = (allowedRoles) => {
  //   return allowedRoles.includes(currentUser?.role)
  // }

  return (
    <>
      {menuItemList.map((menu) => {
        if (menu.allowedEconomies.includes(currentUser?.economy!)) {
          if ((menu.submenu ?? []).length > 0) {
            return (
              <MenuInnerWithSub
                key={menu.title}
                title={menu.title}
                to={menu.to || ''}
                hasArrow={true}
                menuPlacement='bottom-start'
                menuTrigger="{default:'click', lg: 'hover'}"
              >
                {menu.submenu?.map((submenu) => {
                  return (
                    <MenuItem
                      key={submenu.title}
                      title={submenu.title}
                      to={submenu.to || ''}
                      hasBullet={true}
                      refresh={true}
                    />
                  )
                })}
              </MenuInnerWithSub>
            )
          }
          return (
            <MenuItem
              key={menu.title}
              title={menu.title}
              to={menu.to || ''}
              disabled={menu.disabled}
            />
          )
        }
        return null
      })}

      {/* <MenuItem title={intl.formatMessage({id: 'MENU.DASHBOARD'})} to='/dashboard' />  */}
    </>
  )
}
